/**
 * Матеріали блогу.
 *
 * Раніше ця стаття жила прямо в секції на головній і починалася словами
 * «УВАГА!!! До 8 липня 2026 року необхідно оновити ліцензійні дані!». Строк
 * минув, тож на постійній адресі такий заголовок працював би проти компанії:
 * відвідувач бачив би прострочений заклик, а Google — застарілу сторінку.
 * Тому текст адресований тим, хто до строку не встиг: саме в них зараз
 * реальна проблема.
 *
 * Кожне твердження про норми звірене з текстом актів на zakon.rada.gov.ua,
 * і ці акти перелічені в sources — читач має змогу перевірити нас сам. Чого
 * в першоджерелах немає (штрафів, «пільгових» строків), того немає й тут:
 * для юридичної компанії вигадана подробиця дорожча за пропущену.
 *
 * updated — дата останньої змістовної правки. Вона йде в dateModified і
 * показується читачеві: у статті про строки людині важливо бачити, наскільки
 * текст свіжий.
 *
 * related — slug послуги. Сторінка цієї послуги сама показує посилання на
 * статтю в блоці «Читайте також».
 *
 * keyDates — ті самі дати, що вже названі в тексті статті, зведені в одну
 * шкалу. Нової інформації тут немає й не має бути: у статті про пропущений
 * строк людина насамперед шукає очима, коли саме він сплив, а в суцільному
 * абзаці чотири дати зливаються. deadline — дата, яку шкала виділяє.
 */

export const articles = [
  {
    slug: 'postanova-781-licenzijni-umovy',
    tag: 'Ліцензування',
    crumb: 'Постанова № 781',
    date: '2026-08-28',
    dateLabel: '28 серпня 2026',
    updated: '2026-09-28',
    updatedLabel: '28 вересня 2026',
    title: 'Постанова № 781: що робити, якщо ви не оновили ліцензійні дані до 8 липня',
    metaTitle: 'Постанова № 781: не подали Відомості',
    excerpt:
      'Строк подання Відомостей за новою формою минув 8 липня 2026 року. Розбираємо, що змінила Постанова КМУ № 781, чим ризикує заклад, який не встиг, і що робити зараз.',
    metaDescription:
      'Постанова № 781 зобов’язала ліцензіатів подати до МОЗ Відомості за новою формою до 8 липня 2026 року. Що робити, якщо строк пропущено, і що — якщо вже подали.',
    lede: 'До уваги керівників медичних закладів та лікарів-ФОП!',
    intro: [
      '8 січня 2026 року набрала чинності постанова Кабінету Міністрів від 2 липня 2025 року № 781 «Про внесення змін до Ліцензійних умов провадження господарської діяльності з медичної практики». Вона виклала в новій редакції форми заяв і Відомостей, що подаються до МОЗ, і додала до Ліцензійних умов кілька нових вимог.',
      'Для чинних ліцензіатів головне в ній — пункт 2: усі, хто отримав ліцензію до набрання постановою чинності, мали протягом року з дня її опублікування подати до МОЗ Відомості про стан матеріально-технічної бази та персонал за новою формою. Постанову опубліковано 8 липня 2025 року, тож строк сплив 8 липня 2026 року. Винятку для закладів, у яких нічого не змінилося, постанова не робить.'
    ],
    keyDates: [
      { date: '2025-07-08', label: '8 липня 2025', text: 'Постанову № 781 опубліковано' },
      { date: '2026-01-08', label: '8 січня 2026', text: 'Постанова набрала чинності' },
      { date: '2026-07-08', label: '8 липня 2026', text: 'Сплив строк подання Відомостей за новою формою', deadline: true },
      { date: '2026-09-01', label: '1 вересня 2026', text: 'Форму Відомостей змінено постановою № 813' }
    ],
    changesTitle: 'Що змінила постанова',
    changes: [
      {
        label: 'Нова форма Відомостей',
        text: 'Додаток 2 до Ліцензійних умов — Відомості про стан матеріально-технічної бази, наявність персоналу із зазначенням його освітнього і кваліфікаційного рівня — викладено в новій редакції. Саме цей документ мали подати всі, хто отримав ліцензію до 8 січня 2026 року.'
      },
      {
        label: 'Доступність для маломобільних груп',
        text: 'Ліцензіат зобов’язаний забезпечити доступність місць провадження діяльності для осіб з інвалідністю та інших маломобільних груп населення, а у Відомостях для цього є окремий пункт. Ліцензіати, чиї місця провадження діяльності розташовані на територіях можливих або активних бойових дій, подають цю частину Відомостей протягом року з дня завершення бойових дій.'
      },
      {
        label: 'Нова спеціальність — окремою заявою',
        text: 'Щоб почати працювати за новою спеціальністю або новим видом допомоги, ліцензіат подає заяву про розширення провадження медичної практики (додаток 8) з тими самими документами, що й для отримання ліцензії. Для повного або часткового припинення діяльності тепер теж є окрема заява (додаток 9).'
      },
      {
        label: 'Реабілітація й мобільні команди',
        text: 'Медичну допомогу можуть надавати виїзні мультидисциплінарні команди в порядку, визначеному МОЗ, а реабілітаційну — мультидисциплінарні реабілітаційні команди в мобільному режимі. Якщо реабілітаційну допомогу надає така команда, заклад затверджує індивідуальний реабілітаційний план і надає допомогу відповідно до мети, визначеної в цьому плані або в програмі терапії.'
      },
      {
        label: 'Замісна терапія',
        text: 'Заборонено провадити медичну практику в багатоквартирних будинках з метою надання замісної підтримувальної терапії з використанням наркотичних засобів — зокрема лікарям-ФОП за спеціальністю «наркологія».'
      },
      {
        label: 'Контроль з боку держави-агресора',
        text: 'Здобувач ліцензії чи ліцензіат не може прямо чи опосередковано перебувати під контролем резидентів держав, які здійснюють збройну агресію проти України, і не може мати з ними торговельних відносин.'
      }
    ],
    riskTitle: 'Чим ризикує заклад, який не подав Відомості',
    risk: [
      'Окремого покарання за пропущений строк постанова не встановлює. Але й обов’язок вона не скасовує: документ однаково треба подати, і краще — до того, як до закладу прийде перевірка.',
      'Загальний механізм визначає Закон «Про ліцензування видів господарської діяльності». Якщо перевірка виявляє порушення ліцензійних умов, МОЗ видає розпорядження про їх усунення (стаття 19). Невиконане розпорядження — підстава зупинити дію ліцензії, а повторне порушення тих самих вимог протягом року — підстава припинити її (стаття 16).'
    ],
    todoTitle: 'Що робити зараз',
    todo: [
      {
        title: 'Якщо Відомості ще не подані',
        steps: [
          'Візьміть чинну форму — додаток 2 до Ліцензійних умов у поточній редакції. З 1 вересня 2026 року до неї внесено зміни постановою № 813 від 24 червня 2026 року, тож бланк, збережений торік, може вже не відповідати.',
          'Заповнюйте за тим, що є в закладі сьогодні, а не за старою ліцензійною справою: приміщення й кабінети з площами, обладнання, персонал з освітою та кваліфікацією, доступність для маломобільних груп. Під час перевірки саме ці Відомості звірятимуть із дійсністю.',
          'Перед поданням звірте назву, адресу й місця провадження діяльності з даними ЄДР. Розбіжність між ними все одно доведеться пояснювати або виправляти, тож краще усунути її до подання.',
          'Подайте Відомості до МОЗ і збережіть підтвердження подання — хоч би яким способом ви подавали. Воно знадобиться, якщо під час перевірки постане питання, чи документ узагалі подавали.'
        ]
      },
      {
        title: 'Якщо Відомості вже подані',
        steps: [
          'Збережіть копію поданих Відомостей разом із підтвердженням подання: це тепер ваша точка відліку, з якою порівнюватимуть заклад.',
          'Перевірте, чи нічого не змінилося після подання: новий або звільнений лікар, інше обладнання, переобладнаний кабінет.',
          'Про кожну таку зміну МОЗ треба повідомити протягом місяця з дня, коли вона сталася, — через електронний кабінет ліцензіата, особисто або поштою з описом вкладення. До повідомлення додаються Відомості лише з тими даними, які змінилися (підпункт 10 пункту 13 Ліцензійних умов).',
          'Нова спеціальність оформлюється не повідомленням, а заявою про розширення провадження медичної практики.'
        ]
      }
    ],
    actionsTitle: 'Чим ми можемо допомогти',
    actions: [
      'Проведемо аудит вашої ліцензійної справи на відповідність вимогам Постанови № 781.',
      'Підготуємо Відомості за чинною формою додатка 2.',
      'Подамо пакет документів до МОЗ «під ключ» та проконтролюємо внесення змін до реєстру.'
    ],
    sources: [
      {
        label: 'Постанова КМУ від 02.07.2025 № 781 «Про внесення змін до Ліцензійних умов провадження господарської діяльності з медичної практики»',
        href: 'https://zakon.rada.gov.ua/laws/show/781-2025-%D0%BF'
      },
      {
        label: 'Ліцензійні умови провадження господарської діяльності з медичної практики (постанова КМУ від 02.03.2016 № 285), чинна редакція',
        href: 'https://zakon.rada.gov.ua/laws/show/285-2016-%D0%BF'
      },
      {
        label: 'Закон України «Про ліцензування видів господарської діяльності»',
        href: 'https://zakon.rada.gov.ua/laws/show/222-19'
      }
    ],
    related: 'licenzuvannya-medychnoyi-praktyky',
    relatedLead: 'Як проходить ліцензування загалом і що ми перевіряємо ще до подання документів, розказуємо на сторінці'
  }
];

export const findArticle = (slug) => articles.find((a) => a.slug === slug) || null;
